// @flow
import { styled } from 'mz-ui-kit'

export const Container = styled<{ $loading?: boolean }>(
  'div',
  ({ $loading }) => ({
    opacity: $loading ? 0.4 : 1,
    marginTop: '10px',
  })
)

export const Title = styled('div', {
  marginBottom: '5px',
  fontWeight: 'bold',
})

export const AccordingDatabase = styled('div', {
  marginTop: '10px',
  fontStyle: 'italic',
})
